// src/components/DisplaySettings.tsx
//
// Compact text-size control. Exposed to SYSTEM ADMINS ONLY for now (gated at
// the call site in LandingPage) as a preview of the accessibility scaling.
// Changing it applies immediately app-wide and persists per-browser; 'Normal'
// switches back. See src/lib/displayPrefs.ts.

import { useState } from 'react';
import { Type } from 'lucide-react';
import {
  getStoredScale,
  storeScale,
  SCALES,
  SCALE_LABEL,
  type UiScale,
} from '../lib/displayPrefs';

export default function DisplaySettings() {
  const [scale, setScale] = useState<UiScale>(getStoredScale());

  return (
    <div
      className="flex items-center gap-1.5"
      title="Text size — admin preview. Applies to this browser only."
    >
      <Type size={15} className="text-slate-400 shrink-0" />
      <select
        value={scale}
        onChange={(e) => {
          const v = e.target.value as UiScale;
          setScale(v);
          storeScale(v);
        }}
        aria-label="Text size"
        className="bg-slate-800/60 border border-slate-700/50 text-slate-200 text-xs rounded-lg pl-2 pr-6 py-1.5 cursor-pointer hover:border-slate-600 focus:outline-none focus:border-blue-500/40"
      >
        {SCALES.map((s) => (
          <option key={s} value={s} className="bg-slate-800 text-slate-200">
            {SCALE_LABEL[s]}
          </option>
        ))}
      </select>
    </div>
  );
}
